<script setup lang="ts">
import useGlobalAlert from '../composables/useGlobalAlert';

const {alerts} = useGlobalAlert();
</script>

<template lang="pug">
.itlp-checkout-section-error(v-for='alert of alerts')
	span(v-html='alert.message')
</template>